<template>
  <div
    class="profile-wrapper"
    style="
      flex: 1;
      flex-direction: column;
      display: flex;
      max-width: 100%;
      height: 100vh;
    "
    ref="main"
  >
    <el-dialog
      :visible.sync="showHistory"
      title="Modül Konfigrasyon Değişim Günlüğü"
    >
      <ul>
        <li v-for="i in configHistory">
          <div
            style="color: white; padding: 10px 20px"
            v-if="i.currentSpeed || i.speed"
          >
            HIZ: {{ i.currentSpeed }}
            {{ i.speed }}
          </div>
          <div
            style="color: white; padding: 10px 20px"
            v-if="i.level || i.currentLevel"
          >
            LEVEL:
            {{ i.level || i.currentLevel }}
          </div>
          <div
            style="color: white; padding: 10px 20px"
            v-if="i.mode || i.currentMode"
          >
            MODE:
            {{ i.mode || i.currentMode }}
          </div>
        </li>
      </ul>
    </el-dialog>
    <div
      style="
        width: 100%;
        font-size: 24px;
        background-color: #1c449c;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 15px;
      "
      class="dark-inverted"
    >
      <span
        v-if="activeStep.program.module.slug != 'video'"
        style="font-weight: bold; color: white; width: 70px; margin-right: 10px"
        >{{
          timer > 0
            ? moment()
                .set({ second: 0, hour: 0, minute: 0 })
                .add({ seconds: timer })
                .format("mm:ss")
            : ""
        }}
      </span>
      <span
        v-else
        style="font-weight: bold; color: white; width: 70px; margin-right: 10px"
        >{{
          timer > 0
            ? moment()
                .set({ second: 0, hour: 0, minute: 0 })
                .add({ seconds: videoDuration - timer })
                .format("mm:ss")
            : ""
        }}
      </span>

      <div
        style="display: flex; flex: 1; align-items: center"
        v-if="activeCourse.course.type == 'video'"
      >
        <template
          v-for="(step, stepIndex) in lodash.orderBy(
            activeCourse.steps.filter((k) => k.step == $route.params.step),
            ['order_no'],
            ['asc']
          )"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="step.program.module.title"
            placement="bottom-start"
          >
            <div
              style="
                background-color: white;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 15px;
              "
              class="circle"
            >
              <i
                class="fas fa-play"
                v-if="step.program.module.slug == 'video'"
                :style="stepIndex == currentStep - 1 ? 'color: orange' : ''"
              ></i>
              <i
                v-else
                class="fas fa-shapes"
                :style="stepIndex == currentStep - 1 ? 'color: orange' : ''"
              ></i>
            </div>
          </el-tooltip>
          <div
            style="
              display: flex;
              flex: 1;
              height: 5px;
              background-color: white;
              position: relative;
              align-items: center;
              margin-right: 15px;
            "
          >
            <div
              style="
                width: 10%;
                height: 5px;
                background-color: orange;
                position: relative;
              "
              class="progg"
              :style="
                stepIndex < currentStep - 1
                  ? 'width: 100%;'
                  : stepIndex == currentStep - 1
                  ? 'width: ' +
                    (step.program.module.slug == 'video'
                      ? (timer / videoDuration) * 100 + '%'
                      : 100 -
                        Math.abs(
                          timer == 0
                            ? 100
                            : (timer / step.program.seconds) * 100
                        ) +
                        '%')
                  : 'width: 0%;'
              "
            ></div>
            <div
              style="
                position: absolute;
                left: 10%;
                width: 15px;
                height: 15px;
                background-color: orange;
                border-radius: 50%;
                z-index: 9;
              "
              v-if="currentStep - 1 == stepIndex"
              class="circle"
              :style="{
                left:
                  step.program.module.slug == 'video'
                    ? parseFloat((timer / videoDuration) * 100) + '%'
                    : 100 -
                      Math.abs(
                        timer == 0 ? 100 : (timer / step.program.seconds) * 100
                      ) +
                      '%',
              }"
            ></div>
            <div
              style="
                height: 5px;
                background-color: white;
                width: 15px;
                position: absolute;
                right: -15px;
              "
              :style="{
                backgroundColor:
                  stepIndex < currentStep - 1 ? 'orange' : 'white',
              }"
            ></div>
          </div>
        </template>
      </div>

      <span style="display: flex; align-items: center">
        <span
          v-if="steps != null && activeCourse.course.type != 'video'"
          style="font-weight: bold; color: white; margin-left: 10px"
          >{{ currentStep }}/{{
            activeCourse.steps.filter(
              (k) => k.program.step == $route.params.step
            ).length
          }}</span
        >

        <span
          style="color: white; font-size: 17px; margin-left: 10px"
          v-if="activeStep && activeCourse.course.type != 'video'"
          >{{ $t("cats." + activeStep.program.module.category) }} >
          {{ $t("modules." + activeStep.program.module.title) }}</span
        >
        <a
          href="javascript:;"
          style="color: white; margin-left: 30px"
          @click="fullScreen"
        >
          <i class="fas fa-expand"></i>
        </a>

        <a
          href="javascript:;"
          style="color: white; margin-left: 20px; margin-right: 10px"
          @click="
            $store.state.selectedTick2 == 'sessiz'
              ? ($store.state.selectedTick2 = 'Ses1')
              : ($store.state.selectedTick2 = 'sessiz')
          "
        >
          <i
            :class="
              'fas fa-' +
              ($store.state.selectedTick2 == 'sessiz'
                ? 'volume-mute'
                : 'volume-up')
            "
          ></i>
        </a>

        <label
          class="dark-mode ml-auto"
          style="
            transform: scale(0.6);
            margin-left: 10px;
            display: inline-block;
          "
        >
          <input type="checkbox" v-model="$store.state.darkmode" />
          <span></span>
        </label>

        <a
          @click="$store.state.scale -= 0.05"
          href="javascript:;"
          style="color: white; margin-left: 10px; margin-right: 10px"
        >
          <i class="fas fa-search-minus"></i>
        </a>

        <a
          @click="$store.state.scale += 0.05"
          href="javascript:;"
          style="color: white; margin-left: 10px; margin-right: 10px"
        >
          <i class="fas fa-search-plus"></i>
        </a>

        <a
          @click="back"
          href="javascript:;"
          style="color: white; margin-left: 30px; margin-right: 10px"
        >
          <i class="fas fa-times"></i>
        </a>
      </span>
    </div>
    <div
      v-if="
        $refs.activeModule &&
        $store.state.user.tester == 555 &&
        activeCourse.course.type != 'video'
      "
      style="
        width: 100%;
        background-color: #333;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      "
    >
      <div style="display: flex; align-items: center; justify-content: center">
        <div
          style="color: white; padding: 10px 20px"
          v-if="$refs.activeModule.currentSpeed || $refs.activeModule.speed"
        >
          HIZ: {{ $refs.activeModule.currentSpeed }}
          {{ $refs.activeModule.speed }}
        </div>
        <div
          style="color: white; padding: 10px 20px"
          v-if="$refs.activeModule.level || $refs.activeModule.currentLevel"
        >
          LEVEL:
          {{ $refs.activeModule.level || $refs.activeModule.currentLevel }}
        </div>
        <div
          style="color: white; padding: 10px 20px"
          v-if="$refs.activeModule.mode || $refs.activeModule.currentMode"
        >
          MODE:
          {{ $refs.activeModule.mode || $refs.activeModule.currentMode }}
        </div>
        <div
          @click="$refs.activeModule.settings = true"
          style="color: white; padding: 10px 20px"
        >
          <i class="fas fa-cog"></i>
        </div>
        <a
          href="javascript:;"
          style="color: white; font-size: 17px"
          @click="next"
          v-if="$store.state.user.tester == 1"
        >
          <i class="fas fa-arrow-right"></i>
        </a>
        <a
          href="javascript:;"
          style="color: white; font-size: 17px"
          @click="showHistory = true"
          v-if="configHistory.length > 0"
        >
          <i class="fas fa-history"></i>
        </a>
      </div>
      <div style="color: white; padding-right: 20px">
        <span
          style="
            display: inline-block;
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 5px;
            padding: 0px 5px;
            margin-right: 10px;
          "
          v-for="i in Object.keys(activeStepProgram)"
          v-if="
            activeStepProgram[i] != null &&
            i != 'module' &&
            i != 'program_id' &&
            i != 'module_id' &&
            i != 'course_id' &&
            i != 'createdAt' &&
            i != 'updatedAt'
          "
        >
          {{ i }}: {{ activeStepProgram[i] }}
        </span>
      </div>
    </div>
    <div
      v-if="started"
      style="
        display: flex;
        flex: 1;
        width: 100%;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      "
      :style="{
        transform: 'scale(' + $store.state.scale + ')',
        transformOrigin: 'top center',
      }"
    >
      <GozEsnetme
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'goz-esnetme'"
      ></GozEsnetme>
      <IkiliUcluBlok
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'ikili-uclu-blok'"
      ></IkiliUcluBlok>
      <SinavIkiliUcluBlok
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'sinav-ikili-uclu-blok'"
      ></SinavIkiliUcluBlok>
      <EsnekGormeAlani
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'esnek-gorme-alani'"
      ></EsnekGormeAlani>
      <GozEsnekligi
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'goz-esnekligi'"
      ></GozEsnekligi>
      <GozRitim
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'goz-ritim'"
      ></GozRitim>
      <AcilanNesnelerYatay
        direction="horizontal"
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'acilan-nesneler-yatay'"
      ></AcilanNesnelerYatay>
      <KareGormeAlani
        direction="vertical"
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'kare-gorme-alani'"
      ></KareGormeAlani>
      <HarfSayma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'harf-sayma'"
      ></HarfSayma>
      <FarkliOlan
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'farkli-olan'"
      ></FarkliOlan>
      <KelimeAvi
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'kelime-avi'"
      ></KelimeAvi>
      <CokluFokus
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'coklu-fokus'"
      ></CokluFokus>
      <CevreFokus
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'cevre-fokus'"
      ></CevreFokus>
      <BlokOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'blok-okuma'"
      ></BlokOkuma>
      <GolgeliOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'golgeli-okuma'"
      ></GolgeliOkuma>
      <GrupOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'grup-okuma'"
      ></GrupOkuma>
      <Takistoskop
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'takistoskop'"
      ></Takistoskop>
      <ZikZak
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'zikzak'"
      ></ZikZak>
      <Siralama
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'siralama'"
      ></Siralama>
      <DuzeltBakalim
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'duzelt-bakalim'"
      ></DuzeltBakalim>
      <BenzerKelimeler
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'benzer-kelimeler'"
      ></BenzerKelimeler>
      <EsAnlamlilar
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'es-anlamlilar'"
      ></EsAnlamlilar>
      <HangisiBuyuk
        :config="activeStepProgram"
        ref="activeModule"
        :getTime="getTime"
        v-if="activeStep.program.module.slug == 'hangisi-buyuk'"
      ></HangisiBuyuk>
      <HizliSecim
        :config="activeStepProgram"
        ref="activeModule"
        :getTime="getTime"
        v-if="activeStep.program.module.slug == 'hizli-secim'"
      ></HizliSecim>
      <HafizandaTut
        :config="activeStepProgram"
        ref="activeModule"
        :getTime="getTime"
        v-if="activeStep.program.module.slug == 'hafiza-ucgeni'"
      ></HafizandaTut>
      <Video
        @goNext="goNext"
        @totalDuration="totalDuration"
        @playerTimeChanged="playerTimeChanged"
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'video'"
      ></Video>
      <HafizaKareleri
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'hafiza-kareleri'"
      ></HafizaKareleri>
      <HafizaKareleri
        ref="activeModule"
        :rotate="true"
        v-if="activeStep.program.module.slug == 'donen-hafiza'"
      ></HafizaKareleri>
      <MetinOkuma
        ref="activeModule"
        :rotate="true"
        v-if="activeStep.program.module.slug == 'metin-okuma'"
      ></MetinOkuma>
      <KelimeEgzersizi
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'kelime-egzersizi'"
      ></KelimeEgzersizi>
      <Bavul
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'bavul'"
      ></Bavul>
      <KarTanesi
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'kar-tanesi'"
      ></KarTanesi>
      <ForChild
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'kare-okuma'"
      ></ForChild>
      <ForChildWord
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'ileri-seviye-kare-okuma'"
      ></ForChildWord>
      <Siir
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'siir'"
      ></Siir>
      <SiirWord
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'ileri-seviye-siir'"
      ></SiirWord>
      <Tekerleme
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'tekerleme'"
      ></Tekerleme>
      <TekerlemeWord
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'ileri-seviye-tekerleme'"
      ></TekerlemeWord>
      <SinavSerbestOkuma
        ref="activeModule"
        :rotate="true"
        v-if="activeStep.program.module.slug == 'sinav-serbest-okuma'"
      ></SinavSerbestOkuma>
      <SinavGolgeliOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'sinav-golgeli-okuma'"
      ></SinavGolgeliOkuma>
      <SinavKelimeAvi
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'sinav-kelime-avi'"
      ></SinavKelimeAvi>
      <SinavGozRitim
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'sinav-goz-ritim'"
      ></SinavGozRitim>
    </div>
    <div
      id="info"
      v-else
      style="
        width: 700px;
        margin: 0 auto;
        background-color: white;
        padding: 50px 20px;
        margin-top: 100px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        position: relative;
        padding-bottom: 100px;
      "
    >
      <div>
        <div class="col-md-12">
          <h1
            class="dark-inverted text-center"
            style="font-size: 22px; font-weight: bold"
          >
            {{ $t("coursedetail.step") }} {{ currentStep }}
          </h1>
          <h1
            class="dark-inverted text-center"
            style="font-size: 28px; font-weight: bold"
          >
            {{ $t("modules." + activeStep.program.module.title) }}
          </h1>

          <h1 class="dark-inverted text-center" style="font-size: 18px">
            {{ $t("cats." + activeStep.program.module.category) }}
          </h1>
          <h1
            class="dark-inverted text-center"
            style="font-size: 22px; font-weight: normal; margin-top: 30px"
          >
            {{ activeStep.program.seconds }} Saniye
          </h1>
          <h1
            class="dark-inverted mt-5"
            style="
              font-size: 18px;
              font-family: Poppins;
              line-height: 28px;
              font-weight: 500;
              text-align: center;
            "
            v-html="activeStep.program.module['description_' + $i18n.locale]"
          ></h1>
          <div
            style="
              position: absolute;
              bottom: 0px;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              left: 0px;
              padding: 10px 15px;
              background: whitesmoke;
            "
          >
            <p style="display: flex; flex: 1">
              {{ $t("coursedetail.zoom") }}
            </p>
            <div>
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                "
              >
                <a
                  @click="$store.state.scale -= 0.05"
                  href="javascript:;"
                  style="
                    color: rgb(28 68 156);
                    margin-left: 10px;
                    margin-right: 10px;
                    font-size: 20px;
                  "
                >
                  <i class="fas fa-search-minus"></i>
                </a>

                <a
                  @click="$store.state.scale += 0.05"
                  href="javascript:;"
                  style="
                    color: rgb(28 68 156);
                    margin-left: 10px;
                    margin-right: 10px;
                    font-size: 20px;
                  "
                >
                  <i class="fas fa-search-plus"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        @click="start"
        style="
          width: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #1c449c;
          border-radius: 25px;
          color: white;
          font-size: 18px;
          margin: 0 auto;
          box-shadow: 0 0 0 #1c449c;
          animation: pulseee 2s infinite;
          padding: 8px 0px;
          margin-top: 30px;
        "
      >
        {{ $t("edetail.start") }}
      </div>
    </div>

    <el-button
      style="position: absolute; right: 5px; bottom: 5px"
      size="mini"
      round
      type="danger"
      @click="report"
      >Hata Bildir</el-button
    >
    <el-dialog :visible.sync="reportPopup" title="Hata Bildir">
      <el-input
        type="textarea"
        v-model="reportForm.description"
        placeholder="Hata bildirimi ile alakalı eklemek istedikleriniz..."
      ></el-input>
      <el-button
        :loading="sendLoading"
        class="mt-2"
        @click="sendReport"
        type="warning"
        >Gönder</el-button
      >
    </el-dialog>

    <el-dialog
      id="emotion_modal"
      :visible.sync="finishVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="700px"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        "
      >
        <img src="/static/images/animation_200_l1eq3aqt.gif" />
        <h3>Bugünkü Egzersizler Tamam {{ $store.state.user.firstname }}!</h3>

        <p
          style="
            font-size: 19px;
            text-align: center;
            margin-bottom: 20px;
            word-break: break-word;
          "
        >
          Bugünkü Egzersizlerin Nasıl Geçti?
        </p>
        <el-rate
          :show-text="true"
          v-model="emotion"
          :icon-classes="iconClasses"
          :texts="[
            $t('app.cokkotu'),
            $t('app.kotu'),
            $t('app.idareeder'),
            $t('app.good'),
            $t('app.super'),
          ]"
          void-icon-class="fas fa-meh-blank"
          :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
        >
        </el-rate>

        <el-button
          round
          type="primary"
          style="
            width: 40%;
            padding: 10px 15px;
            font-size: 18px;
            margin-top: 40px;
          "
          v-if="emotion != 0"
          @click="saveFeedBack"
        >
          {{ $t("app.save") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import GozEsnetme from "@/components/modules/GozEsnetme";
import IkiliUcluBlok from "@/components/modules/IkiliUcluBlok";
import EsnekGormeAlani from "@/components/modules/EsnekGormeAlani";
import GozEsnekligi from "@/components/modules/GozEsnekligi";
import GozRitim from "@/components/modules/GozeRitim";
import AcilanNesnelerYatay from "@/components/modules/AcilanNesnelerYatay";
import KareGormeAlani from "@/components/modules/KareGormeAlani";
import HarfSayma from "@/components/modules/HarfSayma";
import FarkliOlan from "@/components/modules/FarkliOlan";
import KelimeAvi from "@/components/modules/KelimeAvi";
import CokluFokus from "@/components/modules/CokluFokus";
import CevreFokus from "@/components/modules/CevreFokus";
import BlokOkuma from "@/components/modules/BlokOkuma";
import GolgeliOkuma from "@/components/modules/GolgeliOkuma";
import GrupOkuma from "@/components/modules/GrupOkuma";
import Takistoskop from "@/components/modules/Takistoskop";
import ZikZak from "@/components/modules/ZikZak";
import Siralama from "@/components/modules/Siralama";
import DuzeltBakalim from "@/components/modules/DuzeltBakalim";
import BenzerKelimeler from "@/components/modules/BenzerKelimeler";
import EsAnlamlilar from "@/components/modules/EsAnlamlilar";
import axios from "axios";
import HangisiBuyuk from "@/components/modules/HangisiBuyuk";
import Video from "@/components/modules/Video";
import HizliSecim from "@/components/modules/HizliSecim";
import HafizandaTut from "@/components/modules/HafizandaTut";
import HafizaKareleri from "@/components/modules/HafizaKareleri";
import MetinOkuma from "@/components/modules/MetinOkuma";
import DuzeltBakalimKids from "@/components/modules/DuzeltBakalimKids";
import Siir from "@/pages/Siir";
import SiirWord from "@/pages/SiirWord";
import Tekerleme from "@/pages/Tekerleme";
import ForChild from "@/pages/ForKids";
import ForChildWord from "@/pages/ForKidsWord";
import TekerlemeWord from "@/pages/TekerlemeWord";
import Heceleme from "@/pages/Heceleme";
import KelimeEgzersizi from "@/components/modules/KelimeEgzersizi";
import Bavul from "@/components/modules/Bavul";
import KarTanesi from "@/components/modules/KarTanesi";
import html2canvas from "html2canvas";
import SinavIkiliUcluBlok from "@/components/modules/SinavIkiliUcluBlok";
import SinavSerbestOkuma from "@/components/modules/SinavSerbestOkuma";
import SinavGozRitim from "@/components/modules/SinavGozRitim";
import SinavKelimeAvi from "@/components/modules/SinavKelimeAvi";
import SinavGolgeliOkuma from "@/components/modules/SinavGolgeliOkuma";
import $ from "jquery";
export default {
  components: {
    SinavGolgeliOkuma,
    SinavSerbestOkuma,
    SinavKelimeAvi,
    SinavGozRitim,
    SinavIkiliUcluBlok,
    HafizaKareleri,
    EsAnlamlilar,
    BenzerKelimeler,
    GozEsnetme,
    IkiliUcluBlok,
    EsnekGormeAlani,
    GozEsnekligi,
    GozRitim,
    AcilanNesnelerYatay,
    KareGormeAlani,
    HarfSayma,
    FarkliOlan,
    KelimeAvi,
    CokluFokus,
    CevreFokus,
    BlokOkuma,
    GolgeliOkuma,
    GrupOkuma,
    Takistoskop,
    ZikZak,
    Siralama,
    DuzeltBakalim,
    HangisiBuyuk,
    Video,
    HizliSecim,
    HafizandaTut,
    MetinOkuma,
    Siir,
    Tekerleme,
    ForChild,
    DuzeltBakalimKids,
    ForChildWord,
    TekerlemeWord,
    SiirWord,
    Heceleme,
    KarTanesi,
    Bavul,
    KelimeEgzersizi,
  },
  name: "ExerciseDetail",
  data() {
    return {
      currentStep: 1,
      steps: null,
      started: false,
      interval: null,
      timer: 0,
      moment,
      height: 0,
      pause: false,
      configHistory: [],
      showHistory: false,
      videoDuration: 1,
      img: null,
      reportForm: {
        data: null,
        img: null,
        activeStep: null,
        activeStepProgram: null,
        description: null,
      },
      reportPopup: false,
      sendLoading: false,
      iconClasses: {
        1: "fas fa-frown",
        2: "fas fa-meh",
        3: "fas fa-meh-rolling-eyes",
        4: "fas fa-smile-beam",
        5: "fas fa-grin-stars",
      },
      emotion: null,
      finishVisible: false,
      lodash: _,
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    saveFeedBack() {
      axios
        .post("course/feedback", {
          point: this.emotion,
          user_course_id: this.$route.params.course_id,
          day: this.activeCourse.finished_day + 1,
        })
        .then((res) => {
          axios.get("course/list").then((res) => {
            this.$store.state.courses =this.$prepareCourses(res.data.data);
          });
          this.$router.back();
        });
    },
    sendReport() {
      this.sendLoading = true;
      axios
        .post("report/save", this.reportForm)
        .then((res) => {
          this.$message.success(
            "Hata bildiriminizi aldık. En kısa sürede düzeltmiş olacağız. Teşekkürler!"
          );
          this.reportPopup = false;
          this.sendLoading = false;
        })
        .catch((err) => {
          this.$message.success(
            "Hata bildiriminizi aldık. En kısa sürede düzeltmiş olacağız. Teşekkürler!"
          );
          this.reportPopup = false;
          this.sendLoading = false;
        });
    },
    report() {
      html2canvas(this.$refs.main, {
        width:
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        height:
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight,
      }).then((canvas) => {
        this.reportPopup = true;
        this.reportForm.img = canvas.toDataURL("image/png");
        this.reportForm.data = JSON.stringify({
          ...this.$refs.activeModule._data,
        });
        this.reportForm.activeStep = JSON.stringify(this.activeStep);
        this.reportForm.activeStepProgram = JSON.stringify(
          this.activeStepProgram
        );
      });
    },
    getTime() {
      return this.timer;
    },
    totalDuration(time) {
      this.videoDuration = time;
    },
    next() {
      if (this.$store.state.user.tester == 1) {
        this.timer = 1;
      }
    },
    back() {
      if (this.timer > 0) {
        if (confirm(this.$t("coursedetail.confirm"))) {
          this.$router.push({ name: "Courses" });
        }
      } else {
        this.$router.push({ name: "Courses" });
      }
    },
    fullScreen(r) {
      var isInFullScreen =
        (document.fullscreenElement && document.fullscreenElement !== null) ||
        (document.webkitFullscreenElement &&
          document.webkitFullscreenElement !== null) ||
        (document.mozFullScreenElement &&
          document.mozFullScreenElement !== null) ||
        (document.msFullscreenElement && document.msFullscreenElement !== null);

      var docElm = document.documentElement;
      if (!isInFullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen();
        }
      } else {
        if (r == true) {
          return;
        }
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    playerTimeChanged(time) {
      this.timer = time;
    },
    goNext() {
      if (
        this.currentStep ==
        this.activeCourse.steps.filter(
          (k) => k.program.step == this.$route.params.step
        ).length
      ) {
        var config = this.activeStep.program;

        Object.keys(config).map((key) => {
          if (this.$refs.activeModule[key] != undefined)
            config[key] = this.$refs.activeModule[key];
        });

        axios
          .post("course/doneRepeat", {
            id: this.$route.params.course_id,
            step_id: this.activeStep.step_id,
            course_id: this.activeCourse.course_id,
            config,
            stats: [],
          })
          .then((res) => {
            alert("Tekrarı Bitirdiniz");
            this.$router.back();
            return;
          });
      } else {
        var config = this.activeStep.program;

        Object.keys(config).map((key) => {
          if (this.$refs.activeModule[key] != undefined)
            config[key] = this.$refs.activeModule[key];
        });

        axios
          .post("course/doneRepeat", {
            id: this.$route.params.course_id,
            step_id: this.activeStep.step_id,
            course_id: this.activeCourse.course_id,
            config,
            stats: [],
          })
          .then((res) => {
            this.currentStep = this.steps.find(
              (k) => k.order_no == this.currentStep + 1
            ).order_no;
            this.started = false;
          });
      }
    },
    start() {
      this.fullScreen(true);
      this.started = true;
      if (this.activeStep.program.module.slug == "video") return;
      this.timer = this.activeStep.program.seconds;
      this.interval = setInterval(() => {
        if (this.pause) return;
        this.timer -= 1;

        if (this.timer == 0) {
          clearInterval(this.interval);
          if (
            this.currentStep ==
            this.activeCourse.steps.filter(
              (k) => k.program.step == this.$route.params.step
            ).length
          ) {
            var config = this.activeStep.program;

            Object.keys(config).map((key) => {
              if (this.$refs.activeModule[key] != undefined)
                config[key] = this.$refs.activeModule[key];
            });

            axios
              .post("course/doneRepeat", {
                id: this.$route.params.course_id,
                step_id: this.activeStep.step_id,
                course_id: this.activeCourse.course_id,
                config,
                stats: [],
              })
              .then((res) => {
                this.finishVisible = true;
                return;
              });
          } else {
            var config = this.activeStep.program;

            Object.keys(config).map((key) => {
              if (this.$refs.activeModule[key] != undefined)
                config[key] = this.$refs.activeModule[key];
            });

            axios
              .post("course/doneRepeat", {
                id: this.$route.params.course_id,
                step_id: this.activeStep.step_id,
                course_id: this.activeCourse.course_id,
                config,
                stats: [],
              })
              .then((res) => {
                this.currentStep = this.steps.find(
                  (k) => k.order_no == this.currentStep + 1
                ).order_no;
                this.started = false;
              })
              .catch((err) => {
                this.currentStep = this.steps.find(
                  (k) => k.order_no == this.currentStep + 1
                ).order_no;
                this.started = false;
              });
          }
        }
      }, 1000);
    },
  },
  watch: {
    "activeStep.program.module.slug": function () {
      this.pause = false;
    },
  },
  async created() {
    this.$root.$on("pause", (s) => {
      this.pause = s;
    });

    this.$root.$on("done", () => {
      this.pause = false;
      this.timer = 1;
    });

    var course;

    if (
      this.$store.state.courses.length == 0 ||
      !this.$store.state.courses.some(
        (k) => k.course_id == this.$route.params.course_id
      )
    ) {
      await axios.get("course/list").then((res) => {
        this.$store.state.courses = this.$prepareCourses(res.data.data);
        course = JSON.parse(
          JSON.stringify(
            this.$store.state.courses.find(
              (k) => k.id == this.$route.params.course_id
            )
          )
        );
      });
    } else {
      course = JSON.parse(
        JSON.stringify(
          this.$store.state.courses.find(
            (k) => k.id == this.$route.params.course_id
          )
        )
      );
    }

    this.steps = _.orderBy(
      course.steps.filter(
        (k) => k.program.step == this.$route.params.step && k.repeatedAt == null
      ),
      ["step", "order_no"],
      ["asc", "asc"]
    );

    this.currentStep = this.steps[0].order_no;
    return;

    var step = course.steps.find((k) => k.finishedAt != null);
    if (step == null) {
      this.currentStep = 1;
      this.steps = _.orderBy(
        course.steps.filter((k) => k.program.step == 1),
        ["step", "order_no"],
        ["asc", "asc"]
      );
    }
    var last_finished_step = step.program.step;
    console.log(last_finished_step);

    // is last step finished?
    var is_last_step_finished =
      course.steps.filter(
        (k) => k.program.step == last_finished_step && k.finishedAt != null
      ).length ==
      course.steps.filter((k) => k.program.step == last_finished_step).length;

    if (is_last_step_finished) {
      // check date is today
      if (step.finishedAt.indexOf(moment().format("YYYY-MM-DD")) != -1) {
        return "today_finished";
      } else {
        this.currentStep = step.program.step + 1;
        this.steps = _.orderBy(
          course.steps.filter((k) => k.program.step == step.program.step + 1),
          ["step", "order_no"],
          ["desc", "desc"]
        );
        this.currentStep = steps.filter((k) => k.finishedAt != null).length + 1;

        return;
      }
    } else {
      var steps = _.orderBy(
        course.steps.filter((k) => k.program.step == step.program.step),
        ["step", "order_no"],
        ["asc", "asc"]
      );
      // find last step

      this.currentStep = steps.filter((k) => k.finishedAt != null).length + 1;
      this.steps = steps;
    }
  },
  computed: {
    activeStep() {
      if (this.steps == null || this.steps.length == 0) return {};
      return this.steps.find((k) => k.order_no == this.currentStep);
    },
    activeStepProgram() {
      var config = this.activeStep.program;

      // find last config

      var last_config = this.activeCourse.last_config.find(
        (k) => k.module_id == config.module_id
      );

      if (
        last_config != null &&
        last_config != undefined &&
        config.auto_level == 1
      ) {
        "questionMode,questionModeLevel,speed,level,mode,row,col,image,direction"
          .split(",")
          .map((k, index) => {
            if (
              config[k] !== undefined &&
              (config[k] === null || config[k] === "") &&
              last_config[k] !== null &&
              last_config[k] !== ""
            ) {
              config[k] =
                index <= 7 ? parseInt(last_config[k]) : last_config[k];
            }

            if (
              config["questionMode"] == 1 &&
              last_config["questionModeLevel"] == null &&
              config["questionModeLevel"] == null
            ) {
              var last_config_question_mode =
                this.activeCourse.last_config.find(
                  (k) =>
                    k.module_id == config.module_id &&
                    k.questionModeLevel != null
                );
              config["questionModeLevel"] =
                last_config_question_mode["questionModeLevel"];
            }
          });

        Object.keys(this.activeStep.program).map((key) => {
          if (typeof config[key] === "string") {
            if (!isNaN(parseInt(config[key]))) {
              config[key] = parseInt(config[key]);
            }
          }
        });

        return {
          ...config,
          getTime: () => this.timer,
        };
      } else {
        Object.keys(this.activeStep.program).map((key) => {
          if (typeof config[key] === "string") {
            if (!isNaN(parseInt(config[key]))) {
              config[key] = parseInt(config[key]);
            }
          }
        });

        return {
          ...config,
          getTime: () => this.timer,
        };
      }
    },
    activeCourse() {
      return this.$store.state.courses.find(
        (k) => k.id == this.$route.params.course_id
      );
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/RepeatCourse.vue